import { Button, Checkbox } from 'antd'
import type { FilterDropdownProps } from 'antd/es/table/interface'

interface ProjectNameFilterDropdownProps extends FilterDropdownProps {
  filters: { text: string; value: string }[]
}

// Reuses antd's own ant-table-filter-dropdown* class names for consistent
// theming; these are internal antd class names, so an antd upgrade that
// renames them would need a visual check.
export function ProjectNameFilterDropdown({
  filters,
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters
}: ProjectNameFilterDropdownProps) {
  const selectableValues = filters.map(filter => filter.value)
  const allSelected =
    selectableValues.length > 0 &&
    selectableValues.every(value => selectedKeys.includes(value))

  return (
    <div className="ant-table-filter-dropdown">
      <ul className="ant-table-filter-dropdown-menu project-name-filter-list">
        {filters.map(filter => (
          <li key={filter.value} className="project-name-filter-option">
            <Checkbox
              checked={selectedKeys.includes(filter.value)}
              onChange={e => {
                setSelectedKeys(
                  e.target.checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value)
                )
              }}
            >
              {filter.text}
            </Checkbox>
          </li>
        ))}
      </ul>
      <div className="ant-table-filter-dropdown-btns">
        <Button
          type="link"
          size="small"
          disabled={selectedKeys.length === 0}
          onClick={() => clearFilters?.()}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          className="project-name-filter-select-all"
          disabled={allSelected}
          onClick={() => setSelectedKeys(selectableValues)}
        >
          Select all
        </Button>
        <Button type="primary" size="small" onClick={() => confirm()}>
          OK
        </Button>
      </div>
    </div>
  )
}
